// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tv-0";
export var checkoutRateBadgeLink = "_tv-1";